// Customer-support contact, surfaced in user-facing UI (popups,
// blockers, "contact support" hints). Read from VITE_-prefixed env
// at build time so production deploys can override the placeholder
// without code changes.
//
// The fallbacks below are intentionally generic — they keep dev
// builds usable when frontend/.env hasn't been edited, but should
// be replaced with the real public-facing addresses in any
// deployed environment.
//
// IMPORTANT: only PUBLIC contact info belongs here. Anything VITE_*
// is baked into the browser bundle and visible to every visitor.
// Don't add escalation aliases, on-call rotations, internal
// distribution lists, or anything that could leak org structure.

function readEnv(key) {
  try {
    const env = (typeof import.meta !== 'undefined' && import.meta.env) || {};
    const v = env[key];
    return typeof v === 'string' ? v.trim() : '';
  } catch (_e) {
    return '';
  }
}

export const supportConfig = {
  email: readEnv('VITE_SUPPORT_EMAIL') || 'support@glass-i.com',
  mobile: readEnv('VITE_SUPPORT_MOBILE') || '+91 98765 43210'
};

// `tel:` URIs accept digits and a leading +. Strip spaces / dashes
// so the link works on dialers that are picky about the format.
export function supportTelHref() {
  return 'tel:' + supportConfig.mobile.replace(/[^\d+]/g, '');
}

export function supportMailtoHref() {
  return 'mailto:' + supportConfig.email;
}
